/**
 * Volume Discount - Hint & Badge
 * Updates hint based on quantity selector changes
 */
(function() {
  'use strict';

  function initVolumeDiscount() {
    const hintEl = document.querySelector('.js-volume-discount');
    if (!hintEl) return;

    const hintTextEl = hintEl.querySelector('.js-volume-hint-text');
    const quantityInput = document.querySelector('.cart-item-quantity__input[name="quantity"]');

    // Get translations from data attributes (fallbacks in Dutch as default language)
    const hintDefault = hintEl.dataset.hintDefault || 'Bestel 2 stuks voor 5% korting, 3+ voor 10%';
    const hint2Applied = hintEl.dataset.hintTwo || '5% korting toegepast!';
    const hint3Applied = hintEl.dataset.hintThree || '10% korting toegepast!';

    function updateHint(quantity) {
      if (!hintTextEl) return;

      hintEl.classList.remove('is-active');

      if (quantity >= 3) {
        hintTextEl.innerHTML = '<i class="fa-solid fa-check" style="margin-right: 0.25rem;"></i>' + hint3Applied;
        hintEl.classList.add('is-active');
      } else if (quantity === 2) {
        hintTextEl.innerHTML = '<i class="fa-solid fa-check" style="margin-right: 0.25rem;"></i>' + hint2Applied;
        hintEl.classList.add('is-active');
      } else {
        hintTextEl.textContent = hintDefault;
      }
    }

    function handleQuantityChange() {
      const quantity = parseInt(quantityInput?.value, 10) || 1;
      updateHint(quantity);
    }

    // Listen to quantity input
    if (quantityInput) {
      quantityInput.addEventListener('input', handleQuantityChange);
      quantityInput.addEventListener('change', handleQuantityChange);
    }

    // Listen to +/- buttons
    const minusBtn = document.querySelector('.cart-item-quantity__btns.is-min');
    const plusBtn = document.querySelector('.cart-item-quantity__btns.is-plus');

    if (minusBtn) {
      minusBtn.addEventListener('click', () => setTimeout(handleQuantityChange, 10));
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', () => setTimeout(handleQuantityChange, 10));
    }

    // Initialize
    handleQuantityChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVolumeDiscount);
  } else {
    initVolumeDiscount();
  }
})();
